import { IconCheck, IconCommand, IconX } from '@tabler/icons';
import { h } from 'preact';
import { useEffect, useLayoutEffect, useState } from 'preact/hooks';
import { DownloadMenu, Footer, Header } from '../../components';
import Key from './components/Key/Key';

function Point({ children }) {
  return (
    <div class="w-6 h-6 inline-flex rounded-full bg-purple-600 text-gray-50 items-center justify-center mr-3 font-medium text-sm flex-shrink-0 select-none">
      {children}
    </div>
  );
}

function GettingStarted() {
  const [status, setStatus] = useState(null);

  useLayoutEffect(() => {
    setStatus('loading');
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const timeoutId = setTimeout(() => {
      setStatus('missing');
    }, 3000);

    const x = new MutationObserver(() => {
      if (document.querySelector('iframe.untab')) {
        clearTimeout(timeoutId);
        setStatus('ready');
      }
    });
    
    x.observe(document.body, { childList: true });

    () => {
      x.disconnect();
      clearTimeout(timeoutId);
    }
  }, []);

  return (
    <div>
      <Header />
      <main class="h-screen container pt-44 mx-auto px-8 lg:px-32">
        <div class="flex items-center">
          {
            status === 'ready' && (
              <div class="w-8 h-8 inline-flex rounded-full bg-purple-600 text-gray-50 items-center justify-center mr-3 flex-shrink-0">
                <IconCheck className="-ml-px" size={20} />
              </div>
            )
          }
          {
            status === 'missing' && (
              <div class="w-8 h-8 inline-flex rounded-full bg-red-600 text-gray-50 items-center justify-center mr-3 flex-shrink-0">
                <IconX size={20} />
              </div>
            )
          }
          {
            status === 'loading' && (
              <div class="w-6 h-6 inline-block rounded-full bg-purple-600 mr-4 animate-ping flex-shrink-0" />
            )
          }
          <h1 class="font-semibold text-2xl md:text-3xl">
            {status === 'ready' && 'UnTab is successfully installed.'}
            {status === 'loading' && 'Checking if UnTab is installed'}
            {status === 'missing' && 'UnTab is not installed.'}
          </h1>
        </div>
        {
          status === 'ready' && (
            <>
              <h2 class="mt-16 font-semibold text-gray-500 uppercase tracking-wide">Next steps</h2>
              <div class="font-medium mt-4">
                <div class="flex items-center">
                  <Point>1</Point>
                  Use UnTab by pressing
                  
                  <div className="flex space-x-3 items-center mx-3">
                    <Key className="w-10 h-8">Ctrl</Key>
                    <span class="text-lg">+</span>
                    <Key className="w-20 h-8">Shift</Key>
                    <span class="text-lg">+</span>
                    <Key className="w-40 h-8">Space</Key>
                  </div>
                  on Windows, Linux.
                </div>
                <div class="flex items-center ml-48 mt-4">
                  Or
                  <div className="flex space-x-3 items-center mx-4">
                    <Key className="h-8">
                      <div class="h-full w-full flex flex-col justify-between">
                        <IconCommand className="self-end" size={14} />
                        <span>command</span>
                      </div>
                    </Key>
                    <span class="text-lg">+</span>
                    <Key className="w-20 h-8">shift</Key>
                    <span class="text-lg">+</span>
                    <Key className="w-40 h-8">space</Key>
                  </div>
                  on Mac.
                </div>
              </div>

              <div class="font-medium mt-8">
                <div class="flex items-center">
                  <Point>2</Point>
                  <span>
                    Contribute a plugin or theme on
                    {' '}
                    <a className="text-purple-600 hover:text-purple-500 font-semibold" href="https://github.com/blenderskool">
                      GitHub
                    </a>
                    .
                  </span>
                </div>
              </div>
            </>
          )
        }
        {
          status === 'missing' && (
            <>
              <h2 class="mt-16 font-semibold text-gray-500 uppercase tracking-wide">Next step</h2>
              <div class="font-medium mt-4">
                <span>Download the UnTab extension for your browser.</span>
                <div className="mt-6">
                  <DownloadMenu />
                </div>
              </div>
            </>
          )
        }
      </main>

      <Footer />
    </div>
  );
}

export default GettingStarted;
